export default __webpack_public_path__ + "static/media/36t.219f164d.jpg";